import React from 'react';
import { I18nModel } from './types';

export const I18nContext = React.createContext<I18nModel>(undefined as unknown as I18nModel);
